import { useDataTable } from "@/composites/data-table/index";
import type { HardwareItemType } from "@/schemas/hardware";
import { useEffect, useMemo } from "react";

export const useTableToInstall = (
  processKey: string,
  dataSource: HardwareItemType[],
) => {
  const controllerDataTable = useDataTable<HardwareItemType>(processKey);

  useEffect(() => {
    controllerDataTable.setDataSource(dataSource, dataSource.length);
  }, [dataSource]);

  return useMemo(() => controllerDataTable, [controllerDataTable]);
};
